@if ({
  isLoading: isLoading$ | async,
  order: order$ | async
  }; as type) {
  @if (type.order && !type.isLoading) {
    <app-efa-order-overview [order]="type.order"></app-efa-order-overview>
  } @else {
    @if (type.isLoading) {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  }
}
